//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2024
//----------------------------------------------------------------------------------------------------------------
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../SignIn/signin.css"
import NewNavBar from "../ProductionAssistLandingPage/NewNavBar";
import NewFooter from "../WebComponents/NewFooter";
import logo from "../../content/img/applogo_white.png";
import LocalizedStrings from "../../localization/ProductionAssistLandingPage";

class NewSupportPage extends Component {
  openOutlookMail = () => {
    window.open('https://outlook.office.com/mail/deeplink/compose?to=support@production-assist.com', '_blank');
  };
  render() {
    return (
      <div className="newlogin newsupport">
        { !this.props.inApp ? <NewNavBar /> : null}
        <div className="content">
          <img src={logo} alt="production assistant logo" />
          <h1>{LocalizedStrings.SupportHeader}</h1>
          <h1>{LocalizedStrings.WeGotYou}</h1>
          <div className="btn-group">
            <button className="mail" onClick={this.openOutlookMail} >{LocalizedStrings.SendUsEmail}</button>
            <Link to="https://meetings.engagebay.com/MoritzStaffel"><button  className="chat">{LocalizedStrings.ChatWithUs}</button></Link>
          </div>
        </div>
        { !this.props.inApp ? <NewFooter/> : null}
      </div>
    );
  }
}

export default NewSupportPage;
